/* Decades — honest ship-by announcement for the Atlas cart drawer.
 *
 * The Atlas app embed renders an announcement bar (.atlas-upsell-cart-announcement)
 * whose {TIMER} is a fake fixed-duration countdown configured in the Atlas dashboard.
 * This script rewrites that bar with a real claim: a ship-by date computed from
 * Supliful processing (3 business days), and a countdown to the next order-processing
 * batch cutoff (every 4 hours, ET). Ordering inside the window guarantees the
 * ship-by date; the short window keeps the countdown urgent without being false —
 * the next batch simply picks up later orders with a fresh (possibly same) date.
 *
 * Atlas-safety: removing Atlas's #atlas-announcement-timer-value span makes its own
 * timer bail cleanly (it warns and returns when the span is missing). The Atlas
 * dashboard text must keep "{TIMER}" in it — Atlas only shows the bar when the
 * configured text contains that token.
 */
(function () {
  'use strict';

  var PROCESSING_BIZ_DAYS = 3;  // Supliful: usually 2-3 business days
  var CUTOFF_INTERVAL_H = 4;    // processing batch cutoffs at 00/04/08/12/16/20 ET
  var MARKER = 'data-decades-eta';

  function nowET() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }

  function msUntilCutoff() {
    var et = nowET();
    var cutoff = new Date(et);
    var nextHour = (Math.floor(et.getHours() / CUTOFF_INTERVAL_H) + 1) * CUTOFF_INTERVAL_H;
    cutoff.setHours(nextHour, 0, 0, 0);
    return cutoff - et;
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }

  function shipByDate() {
    return addBusinessDays(nowET(), PROCESSING_BIZ_DAYS);
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function fmtCountdown(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (h > 0) return h + 'h ' + String(m).padStart(2, '0') + 'm';
    return String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
  }

  function announcementHtml() {
    return 'Ships by <strong>' + fmtDate(shipByDate()) + '</strong> if you order in the next ' +
      '<strong class="decades-eta-timer">' + fmtCountdown(msUntilCutoff()) + '</strong>';
  }

  var tickInterval = null;

  function rewrite(bar) {
    bar.setAttribute(MARKER, '1');
    bar.innerHTML = announcementHtml();
    if (tickInterval) clearInterval(tickInterval);
    tickInterval = setInterval(function () {
      // Re-query: Atlas re-renders the drawer on cart updates.
      var live = document.querySelector('.atlas-upsell-cart-announcement[' + MARKER + ']');
      if (!live) { clearInterval(tickInterval); tickInterval = null; return; }
      var t = live.querySelector('.decades-eta-timer');
      if (t) t.textContent = fmtCountdown(msUntilCutoff());
      if (msUntilCutoff() <= 1000) live.innerHTML = announcementHtml(); // roll to the next batch at cutoff
    }, 1000);
  }

  var observer = new MutationObserver(function () {
    var bar = document.querySelector('.atlas-upsell-cart-announcement:not([' + MARKER + '])');
    if (bar) rewrite(bar);
  });

  function start() {
    var bar = document.querySelector('.atlas-upsell-cart-announcement');
    if (bar && !bar.hasAttribute(MARKER)) rewrite(bar);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
